/* eslint-disable */


import { SIDEBAR_WIDTH } from '../../Constants/Sidebar/Sidebar.constants';

/**
 * Create styles for `<OrdersPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrdersPage />` styles
 */
const ordersPageStyles = ({ theme }) => ({
  closed: {
    marginLeft: SIDEBAR_WIDTH * -1,
  },
  paper: {
    height: `100%`,
    overflowY: `auto`,
    width: SIDEBAR_WIDTH,
  },
  root: {
    display: `flex`,
    flexDirection: `column`,
    flexGrow: 1,
    transition: theme.transitions.create([`margin`], {
      duration: theme.transitions.duration.enteringScreen,
      easing: theme.transitions.easing.easeOut,
    }),
  },
  sidebarRoot: {
    height: `100%`,
    overflowX: `hidden`,
    overflowY: `auto`,
  },
});

export default ordersPageStyles;
